import { Box, Paper, TextField, Typography, Button } from '@material-ui/core';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { appointmentActionsTypes } from '../../redux/appointment/actions';
import { useHistory } from 'react-router-dom';
import { RAPID_APPOINTMENT } from '../../utils/urls';

const RapidAppointmentForm = ({ session, rapidQueuePush }) => {
  const history = useHistory();
  const queue = history.location.state.queue;
  const handleRapidQueuePush = () => {
    rapidQueuePush({
      identity_document: session.identity_document,
      specialty: queue.specialty,
      appointment_reason: appointmentReason,
    });
    history.push(RAPID_APPOINTMENT);
    // wait 1 second and reload page
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  };
  const [appointmentReason, setAppointmentReason] = useState('');

  return (
    <Box display='flex' justifyContent='center' mt={'150px'}>
      <Paper>
        <Box p={3}>
          <Typography variant='h4'>
            Formulario de solicitud de atención inmediata
          </Typography>
          <TextField
            label='Motivo de consulta'
            fullWidth
            multiline
            onChange={(e) => setAppointmentReason(e.target.value)}
          />
          <Box mt={2} display='flex' justifyContent='right'>
            <Button
              variant='contained'
              color='primary'
              onClick={handleRapidQueuePush}
            >
              Solicitar
            </Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

const mapStateToProps = ({ appointments, session }) => {
  return {
    rapidQueues: appointments.rapidQueues,
    loading: appointments.loading,
    session: session,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getRapidQueues: () =>
    dispatch({ type: appointmentActionsTypes.GET_RAPID_QUEUES }),
  rapidQueuePush: (data) =>
    dispatch({ type: appointmentActionsTypes.RAPID_QUEUE_PUSH, payload: data }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RapidAppointmentForm);
